import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useSelector} from "react-redux";
import {Link, useHistory} from "react-router-dom";
import Footer from "../../../components/footer";

const Checks = (props) => {
    let history = useHistory();
    const check = useSelector(
        (state) => state.checks_module._get_all_checks
    );
    const [data, setData] = useState([]);

    useEffect(() => {
        if (check.data.datos) {
            setData(check.data.datos);
        }
    }, [check]);
    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);


    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);

        }
    }, [props]);


    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_checks').length > 0) {
                act.push({
                    name: "edit",
                    label: "Editar",
                    icon: "bx bx-edit",
                    color: "calendar",
                    onClick: (item) => {
                        history.push(`/cheque/editar/${item.id}`);
                    },
                })

            }
        }
        setActions(act);
    }, [permisos, history]);

    return (
        <div className="app-content content">
            <div className="content-overlay"/>
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-3">
                        <Breadcrumbs
                            title="Cheques"
                            items={[{label: "Cheques", link: "/cheques"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_checks').length > 0 ? <Link
                                        to="/cheque/crear"
                                        className="btn btn-calendar"
                                    >
                                        Crear
                                    </Link> : null
                                }

                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "fecha_creacion",
                                                label: "Fecha de creación",
                                                type: "text",
                                            },
                                            {
                                                name: "numero",
                                                label: "Número de cheque",
                                                type: "text",
                                            },
                                            {
                                                name: "banco",
                                                label: "Banco",
                                                type: "text",
                                            },
                                            {
                                                name: "sociedad",
                                                label: "Sociedad",
                                                type: "text",
                                            },
                                            {
                                                name: "tienda",
                                                label: "Tienda",
                                                type: "text",
                                            },
                                            {
                                                name: "nombre_estado",
                                                label: "Estado",
                                                type: "text",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default Checks;
